import React, { Component } from 'react';
import './EduText.css';
import './EducationSectionRes.css';


const EduText = (props) => {
    return ( 
        <>
        <h3 className='edu'>{props.place}</h3>
        
        
        </>
     );
}
 
export default EduText;